import {
  buildKayKitAvatar,
} from './buildKayKitAvatar'
import { buildLiteCrowdAvatar } from './buildLiteCrowdAvatar'
import {
  buildQuaterniusAvatar,
  type QuaterniusClip,
  playQuaterniusClip,
  playQuaterniusIdle,
  playQuaterniusWalk,
  tickQuaterniusMixer,
} from './buildQuaterniusAvatar'
import { isKayKitCharacterId, resolveCharacterId } from '../model/characterCatalog'
import type { AvatarAppearance } from '../model/types'
import type { BuiltAvatar } from './buildAvatarMesh'

export {
  playQuaterniusClip,
  playQuaterniusIdle,
  playQuaterniusWalk,
  tickQuaterniusMixer,
}
export type { QuaterniusClip }

export type BuildCrowdAvatarOptions = {
  /** Shared-geo chibi for dense demos (hundreds of walkers). */
  lite?: boolean
}

/** Build Quaternius / KayKit / lite crowd avatar from appearance.characterId */
export async function buildCrowdAvatar(
  appearance: AvatarAppearance,
  displayName: string,
  initialClip: QuaterniusClip = 'Walk',
  opts: BuildCrowdAvatarOptions = {},
): Promise<BuiltAvatar> {
  if (opts.lite) {
    return buildLiteCrowdAvatar(appearance, displayName)
  }
  const id = resolveCharacterId(appearance.characterId)
  if (isKayKitCharacterId(id)) {
    return buildKayKitAvatar(appearance, displayName, initialClip)
  }
  return buildQuaterniusAvatar(appearance, displayName, initialClip)
}
